import { removeEmpty } from '@/utils/tools'

// Function that decodes the query from the default query encode function
export default (str) => {
  const obj = {}
  const split = removeEmpty(str.split(',')).map((s) => s.split('|'))
  for (const [key, value] of split) {
    obj[key] = value
  }
  // We return null to ensure normal encoder / decoder behaviour when the decoder fails
  return Object.keys(obj).length > 0 ? obj : null
}
